@if (title) {
  <h3 class="h3 mtn mbl">{{ title }}</h3>
}

@if (pieOptions) {
  <div class="text-center">
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="pieOptions"
      [ngStyle]="{ 'height.px': height, display: 'block', width: '100%' }"
      (click)="pieClickHandler($event)"
    ></highcharts-chart>
  </div>
}
